import { ReportHandler } from 'web-vitals';

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    }).catch((error) => {
      // Silently fail if web-vitals can't be loaded
      if (process.env.NODE_ENV === 'development') {
        console.warn('Web Vitals could not be loaded:', error);
      }
    });
  } else {
    // Default logging in development
    if (process.env.NODE_ENV === 'development') {
      import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
        const logMetric = (metric: any) => {
          console.log(`📊 ${metric.name}:`, {
            value: metric.value,
            rating: metric.rating,
            delta: metric.delta
          });
        };
        
        getCLS(logMetric);
        getFID(logMetric);
        getFCP(logMetric);
        getLCP(logMetric);
        getTTFB(logMetric);
      }).catch(() => {
        // Silently fail
      });
    }
  }
};

export default reportWebVitals;
